/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BodyGetYearlyEndingNav
 */
export interface BodyGetYearlyEndingNav {
    /**
     * 
     * @type {Array<string>}
     * @memberof BodyGetYearlyEndingNav
     */
    brokerAccountIds: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof BodyGetYearlyEndingNav
     */
    years: Array<number>;
}

/**
 * Check if a given object implements the BodyGetYearlyEndingNav interface.
 */
export function instanceOfBodyGetYearlyEndingNav(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "brokerAccountIds" in value;
    isInstance = isInstance && "years" in value;

    return isInstance;
}

export function BodyGetYearlyEndingNavFromJSON(json: any): BodyGetYearlyEndingNav {
    return BodyGetYearlyEndingNavFromJSONTyped(json, false);
}

export function BodyGetYearlyEndingNavFromJSONTyped(json: any, ignoreDiscriminator: boolean): BodyGetYearlyEndingNav {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brokerAccountIds': json['broker_account_ids'],
        'years': json['years'],
    };
}

export function BodyGetYearlyEndingNavToJSON(value?: BodyGetYearlyEndingNav | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'broker_account_ids': value.brokerAccountIds,
        'years': value.years,
    };
}

